/**
 * このpackageはテンプレートエンジンを使わず`innerHTML`で組み立てるため、
 * ユーザー入力・API由来の値をHTMLへ差し込む前に必ずこの関数でエスケープし、
 * XSSを防ぐ(氏名・備考等は利用者本人の入力値だが、他要素との混入や将来の
 * 表示項目追加時の事故を防ぐため一律エスケープする方針とする)。
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
